import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const container: SxStyle = {
  my: (p) => p.spacing(4),
  mx: 'auto',
};

export const content: SxStyle = {
  width: (p) => p.spacing(6),
  height: (p) => p.spacing(6),
  background: (p) => p.palette.common.white,
  borderRadius: '50%',
  m: 'auto',
};

export const logo: SxStyle = {
  width: (p) => p.spacing(3.5),
  height: (p) => p.spacing(3.5),
  background: (p) => p.palette.success[100],
  borderRadius: (p) => p.spacing(1),
  m: 'auto',
};
